/**
 * Resolves the supplied promise, or rejects with a timeout error after `ms`.
 * Used to bound network-bound auth/admin calls so a stalled supabase-js
 * token refresh can never freeze the UI in a "Sending…" state.
 */
export function withTimeout<T>(p: Promise<T>, ms: number, label = "operation"): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const t = setTimeout(() => {
      reject(new Error(`${label} timed out after ${Math.round(ms / 1000)}s. Check your connection and try again.`));
    }, ms);
    p.then(
      (v) => { clearTimeout(t); resolve(v); },
      (e) => { clearTimeout(t); reject(e); },
    );
  });
}
